<template>
    <page :title="$t('main_checkoutSummary')" :breadcrumb="breadcrumb">
        <div class="progress-steps">
            <div class="row" v-if="recreation">
                <div class="col-sm-3 col-md-3">
                    <p class="progress-step active">
                        <i class="fa fa-list"></i>
                        <span class="title">{{ $t('reservation_summary') }}</span>
                    </p>
                </div>
                <div class="col-sm-3 col-md-3">
                    <p class="progress-step inactive">
                        <i class="fa fa-shopping-cart"></i>
                        <span class="title">{{ $t('reservation_checkout') }}</span>
                    </p>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-sm-3 col-md-3">
                    <router-link v-if="!booking" class="progress-step done"
                                 :to="{name: 'Detail', params: {lang: language, id: reservation.campsiteid}}" exact>
                        <i class="fa fa-check"></i>
                        <span class="title">{{ $t('reservation_selectCampsite') }}</span>
                    </router-link>
                    <div v-else class="progress-step done">
                        <i class="fa fa-check"></i>
                        <span class="title">{{ $t('reservation_selectCampsite') }}</span>
                    </div>
                </div>
                <div class="col-sm-3 col-md-3">
                    <router-link class="progress-step done"
                                 :to="{name: this.booking ? 'Booking' : 'Reservation', params: {lang: language, campsite: reservation.campsiteid}}"
                                 exact>
                        <i class="fa fa-bookmark"></i>
                        <span class="title">{{ $t('reservation_reservation') }}</span>
                    </router-link>
                </div>
                <div class="col-sm-3 col-md-3">
                    <p class="progress-step active">
                        <i class="fa fa-list"></i>
                        <span class="title">{{ $t('reservation_summary') }}</span>
                    </p>
                </div>
                <div class="col-sm-3 col-md-3">
                    <p class="progress-step inactive">
                        <i class="fa fa-shopping-cart"></i>
                        <span class="title">{{ $t('reservation_checkout') }}</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="listing-hero mb-3">
            <div class="listing-hero-inner">
                <div class="container">
                    <div v-if="!campsite.mainimage" class="listing-hero-image hidden-sm-down"></div>
                    <div v-if="campsite.mainimage" class="listing-hero-image hidden-sm-down"
                         :title="campsite.mainimage.name"
                         :style="`background-image: url(${campsite.mainimage.source})`"></div>
                    <h1>{{ campsite.campsitename }} <i class="fa fa-check hidden-sm-down"></i></h1>
                    <address>
                        {{ campsite.number }} {{ campsite.straat }}<br>
                        {{ campsite.city }}, {{ campsite.country }} {{ campsite.zipcode }}
                    </address>

                </div>
            </div>
        </div>
        <div class="row">
            <div :class="{'col-sm-12': recreation, 'col-md-4': !recreation}">
                <div class="form-text text-danger" v-if="errors.has('cart')">
                    {{ errors.first('cart') }}
                </div>
                <RecreationCheckoutCart ref="cart" v-if="recreation" :campsite-id="$route.params.campsiteid" :model="cartmodel"/>
                <div class="box" v-else>
                    <div class="box-inner">
                        <div class="box-title">
                            <h3>{{ $t('checkout_summary') }}</h3>
                        </div>
                        <table class="table table-bordered">
                            <tbody>
                            <tr>
                                <td class="title">{{ $t('checkout_from') }}</td>
                                <td class="value">{{ reservation.startdatetime | datetime }}</td>
                            </tr>
                            <tr>
                                <td class="title">{{ $t('checkout_to') }}</td>
                                <td class="value">{{ reservation.enddatetime | datetime }}</td>
                            </tr>
                            <tr>
                                <td class="title">{{ $t('reservation_person') }}</td>
                                <td class="value">{{ reservation.persons }}</td>
                            </tr>
                            <tr v-if="reservation.dogs">
                                <td class="title">{{ $t('reservation_dog') }}</td>
                                <td class="value">{{ reservation.dogs }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="total">
                    <div class="title">{{ $t('checkout_total') }}</div>
                    <div class="value">€ {{ fixDecimals(totalAmountToDisplay / 100) }}</div>
                </div>
                <div v-if="booking || recreation" class="form-group">
                    <button class="btn btn-primary btn-block" v-if="!user.id" @click="goToPayment">
                        <i class="fa fa-user-times" aria-hidden="true"></i>
                        {{ $t('checkout_as_guest') }}
                    </button>
                </div>
            </div>
            <div class="col-md-8">
                <div class="row" v-if="!user.id">
                    <div class="col-md-6" v-if="registrationEnabled">
                        <p class="text-center">{{ $t('checkout_reg_pretext') }}</p>
                        <div class="form-group">
                            <button class="btn btn-outline-primary form-control btn-block" @click="goToRegister">
                                <i aria-hidden="true" class="fa fa-user-plus"></i>
                                {{ $t('checkout_reg_button') }}
                            </button>
                        </div>
                        <p class="text-center text-muted"> {{ $t('checkout_reg_or') }} </p>
                    </div>
                    <div v-if="!booking && !recreation" class="col-md-6">
                        <div class="form-group">
                            <button class="btn btn-primary btn-block" v-if="!user.id" @click="goToPayment">
                                <i class="fa fa-user-times" aria-hidden="true"></i>
                                {{ $t('checkout_as_guest') }}
                            </button>
                        </div>
                        <p class="text-center">{{ $t('checkout_login_existing') }}</p>
                        <login-component label @loggedIn="goToPayment"></login-component>
                    </div>
                </div>
                <div class="row" v-if="user.id">
                    <div class="col-md-12">
                        <div class="form-group">
                            <button class="btn btn-primary btn-block" @click="goToPayment">
                                <i class="fa fa-user" aria-hidden="true"></i>
                                {{ $t('checkout_checkoutAs') }} {{ user.email }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="campsite.termsandconditions">
            <div class="col-md-12">
                <div class="box">
                    <div class="box-inner">
                        <div class="box-title">
                            <h2>{{$t('recreation_termsandconditions_header')}}</h2>
                        </div>
                        <!-- /.box-title -->
                        <div class="row">
                        <div class="col-md-12" v-html="campsite.termsandconditions">
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </page>
</template>

<script>
import Page from './utilities/Page'
import LoginComponent from './utilities/LoginComponent'
import { mapGetters, mapMutations } from 'vuex'
import { API } from '../api/axios'
import { campsiteHelper } from '@/mixins/campsiteHelperMixin'
import RecreationCheckoutCart from './RecreationCheckoutCart'
import moment from 'moment'

export default {
  name: 'Checkout',
  components: { Page, LoginComponent, RecreationCheckoutCart },
  mixins: [campsiteHelper],
  props: {
    mode: {
      type: String,
      default: 'campsite',
    },
  },
  data () {
    return {
      campsite: {},
      cartmodel: {
        email: '',
        validFrom: new Date(),
        productinfo: [],
      },
    }
  },
  computed: {
    ...mapGetters(['reservation', 'language', 'user', 'savedQueryParams', 'jail']),
    booking () {
      return this.mode === 'ecpWidget'
    },
    recreation () {
      return this.mode === 'recreation'
    },
    registrationEnabled () {
      return false
    },
    breadcrumb () {
      if (this.booking || this.recreation) return []
      return [
        {
          name: 'Listings',
          query: this.savedQueryParams,
        },
        {
          name: 'Detail',
          params: { lang: this.language, id: this.campsite.id },
          display: this.campsite.campsitename,
        },
      ]
    },
    totalAmountToDisplay () {
      if (this.recreation) {
        if (this.cartmodel.productinfo.length <= 0) return 0
        // console.log(this.cartmodel.productinfo)
        const totalCalculator = (accumulator, current) => accumulator + (current.amount || 0) * current.price
        return this.cartmodel.productinfo.reduce(totalCalculator, 0) * 100
      }
      return this.reservation.totalamount + this.reservation.taxamount
    },
  },
  methods: {
    ...mapMutations(['toggleSidebar', 'setJail', 'hideFooter']),
    fixDecimals (number) {
      return number.toFixed(2)
    },
    getCampsite () {
      let campsiteId
      if (this.recreation) {
        campsiteId = this.$route.params.campsiteid
      } else {
        campsiteId = this.reservation.campsiteid
      }
      API.get(`/campsites/${campsiteId}?languageid=${this.language}`)
        .then(response => {
          this.campsite = response.data.campsitelist[0]
        })
    },
    goToPayment () {
      this.setAuthCookie(this.user.token)
      if (this.recreation) {
        this.$refs.cart.callValidation().then(result => {
          if (!result) return
          let email = encodeURIComponent(this.cartmodel.email)
          let validFrom = encodeURIComponent(moment(this.cartmodel.validFrom).format('YYYY-MM-DD'))
          API.post(`/shoppingcart/payment/lang/${this.language}?emailAddress=${email}&validFrom=${validFrom}`,
            this.cartmodel.productinfo.filter(p => p.amount > 0).map(p => {
              return {
                productid: p.id,
                amount: +(p.amount)
              }
            }))
            .then(response => {
              window.location.href = response.data.checkouturl
            })
            .catch(error => {
              switch (error.response.status) {
                case 412:
                case 500:
                default:
                  this.errors.add({ field: 'cart', msg: error.response.data })
              }
            })
        })
      } else {
        API.get(`/payment/start/lang/${this.language}/id/${this.reservation.id}`)
          .then(response => {
            window.location.href = response.data.checkouturl
          })
      }
    },
    goToRegister () {
      this.$router.push({ name: 'Register', params: { ...this.$route.params, transaction: this.reservation.id } })
    },
  },
  mounted () {
    if (this.booking || this.recreation) this.setJail(true)
    this.getCampsite()
  },
  created () {
    if (this.recreation) this.hideFooter(true)
  },
}
</script>

<style scoped>
    .total, .subtotal {
        background-color: #323232;
    }

</style>



// WEBPACK FOOTER //
// src/components/Checkout.vue